import React, { useState } from "react";
import {
    Phone,
    Youtube,
    Send,
    Mail,
    ChevronRight,
    ChevronLeft,
} from "lucide-react";

const SocialMediaPanel = () => {
    const [isOpen, setIsOpen] = useState(false);

    const togglePanel = () => {
        setIsOpen(!isOpen);
    };

    const supportLinks = [
        {
            icon: <Phone size={22} />,
            href: "tel:+918709364253",
            label: "Call Support",
        },
        {
            icon: <Youtube size={22} />,
            href: "https://youtube.com/@pyq_pedia",
            label: "Video Lectures",
        },
        {
            icon: <Send size={20} className="ml-[-2px] mt-[2px]" />,
            href: "https://t.me/PYQ_Pedia",
            label: "Student Group",
        },
        {
            icon: <Mail size={22} />,
            href: "mailto:upscpyqpedia@gmail.com",
            label: "Email Query",
        },
    ];

    return (
        <div
            className={`fixed top-1/2 -translate-y-1/2 left-0 z-[12000] flex items-center transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
                isOpen ? "translate-x-0" : "-translate-x-[60px]"
            }`}
        >
            {/* Main Sidebar Body (Professional Software Tool Vibe) */}
            <div className="w-[60px] bg-neutral-900 border-r border-y border-neutral-800 rounded-r-xl shadow-[10px_0_30px_rgba(0,0,0,0.15)] py-4 flex flex-col gap-2 relative z-10">
                {supportLinks.map((link, index) => (
                    <a
                        key={index}
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="relative flex items-center justify-center w-full h-12 text-gray-400 hover:text-white hover:bg-neutral-800 border-l-4 border-transparent hover:border-yellow-500 transition-all duration-200 group cursor-pointer"
                    >
                        {link.icon}

                        {/* Sharp, Native-Software Style Tooltip */}
                        <span className="absolute left-full ml-2 px-3 py-1.5 bg-white text-neutral-900 text-xs font-bold tracking-wide rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 -translate-x-2 group-hover:translate-x-0 whitespace-nowrap shadow-lg pointer-events-none">
                            {link.label}
                            {/* Tooltip Triangle Pointer */}
                            <span className="absolute top-1/2 -left-1 -translate-y-1/2 w-2.5 h-2.5 bg-white rotate-45 rounded-sm"></span>
                        </span>
                    </a>
                ))}
            </div>

            {/* Integrated Toggle Tab */}
            <button
                className="w-6 h-16 bg-neutral-900 border-r border-y border-neutral-800 rounded-r-lg shadow-xl flex items-center justify-center text-gray-400 hover:text-yellow-500 hover:bg-neutral-800 transition-colors focus:outline-none -ml-[1px] relative z-0"
                onClick={togglePanel}
                aria-label="Toggle Support Sidebar"
            >
                {isOpen ? (
                    <ChevronLeft size={16} />
                ) : (
                    <ChevronRight size={16} />
                )}
            </button>
        </div>
    );
};

export default SocialMediaPanel;
